
export default {



  head() {
    return {
      title: `Les communes du département ${this.region.name} (${this.region.fr_code_dep}) - ${this.$config.siteTitle}`,
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: `Le département ${this.region.article} ${this.region.name} appartient à la région ` +
            `${this.region.parent.name}. Il compte ${this.formatNumericValue(this.region.population)} habitants répartis sur ${this.region.total_cities} communes. `
        }
      ]
    }
  },

  async asyncData({ $axios, $config: { baseApiURL }, route, params }) {

    const pathMapping = {
      '/regions/mayotte/': { region: 'mayotte', departement: 'mayotte-1' },
      '/regions/martinique/': { region: 'martinique', departement: 'martinique-1' },
      '/regions/guyane/': { region: 'guyane', departement: 'guyane-1' },
      '/regions/guadeloupe/': { region: 'guadeloupe', departement: 'guadeloupe-1' },
      '/regions/la-reunion/': { region: 'la-reunion', departement: 'la-reunion-1' },
    };

    let region, departement;

    if (pathMapping[route.path]) {
      ({ region, departement } = pathMapping[route.path]);
    } else {
      ({ region, departement } = params);
    }

    const props = await $axios.$get(`${baseApiURL}/regions/${region}/departements/${departement}`);

    return {
      cities: props.cities,
      region: props.region,
      reviews: props.reviews,
      breadcrumbs: props.breadcrumbs
    };
  },
  computed: {
    sortedCities() {
      return this.cities
        .sort((a, b) => {
          return a.full_name.localeCompare(b.full_name);
        })
        .map((city, index, arr) => {
          const prevCity = arr[index - 1];
          city.firstLetter = city.name.charAt(0);
          city.firstLetterHasChanged = (prevCity?.name.charAt(0) !== city.firstLetter) ? true : false;

          return city;
        });
    }
  }
}
